<p500-ui-many-items
  *ngIf="data?.length; else emptyTmpl"
  [data]="mappedData"
  [title]="title"
  [tmpl]="tmpl"
  [buttonTmpl]="previewTmpl"
></p500-ui-many-items>
<ng-template let-data="data" #tmpl>
  <span>{{ data?.name || data?.description }}</span>
  <a *ngIf="data?.file" [href]="data.file" download target="_blank" class="ml-10">
    <p500-ui-icon [size]="'16px'" name="download"></p500-ui-icon>
  </a>
</ng-template>
<ng-template let-open="open" #previewTmpl>
  <div class="c-field-value c-field-value--view-mode d-flex">
    <span class="c-field-value__icon" (click)="open($event)">
      <p500-ui-icon name="menu-eye"></p500-ui-icon>
    </span>
    <span>{{ text }}</span>
  </div>
</ng-template>
<ng-template #emptyTmpl>
  <gtd-ui-field-default-string-or-empty></gtd-ui-field-default-string-or-empty>
</ng-template>
